export const rolesPermissionsData = [
  {
    key: "1",
    ROLE: "Owner",
    CREATEDDATE: "24 Jan 2025",
    STATUS: "Active",
  },
  {
    key: "2",
    ROLE: "Admin",
    CREATEDDATE: "24 Jan 2025",
    STATUS: "Active",
  },
  {
    key: "3",
    ROLE: "Manager",
    CREATEDDATE: "19 Dec 2024",
    STATUS: "Inactive",
  },
  {
    key: "4",
    ROLE: "Customer",
    CREATEDDATE: "11 Dec 2024",
    STATUS: "Active",
  },
  {
    key: "5",
    ROLE: "Accountant",
    CREATEDDATE: "29 Nov 2024",
    STATUS: "Active",
  },
  {
    key: "6",
    ROLE: "Inspector",
    CREATEDDATE: "18 Oct 2024",
    STATUS: "Active",
  },
];
